import styled from 'styled-components';
import { Flex, FlexProps } from '@mantine/core';

export const StyledAuditContainer = styled(Flex)<FlexProps>`
	height: 100%;
	gap: 1rem;
	padding: 16px;
	align-items: stretch;
`;

export const StyledDetailPanel = styled.div`
	flex: 1;
	min-width: 0;
	background-color: white;
	border-radius: 0.5rem;
`;

export const StyledSessionDetails = styled.div`
	flex: 0 0 20rem;
	min-width: 20rem;
	max-width: 20rem;
	height: 100%;
`;
